module.exports = __webpack_public_path__ + "img/chest.6e2aea4c.png";